export default __webpack_public_path__ + "57f9d7a9a36107ca413a4aa506020d60.png";